import DashPanelSection from './DashPanelSection'

export default DashPanelSection
